const state = {
  criteriaList: [],
  gridLoading: true,
  gridLoadError: false,
  currentDocumentIndex: 1,
  sortOrder: {
    FieldName: '',
    Order: 'asc'
  },
  storedView: '',
  storedFolderId: null
}

const getters = {
  getCriteriaList: (state) => { return state.criteriaList },
  getAppliedCriteria: (state) => { return state.criteriaList.filter(x => x.IsApplied === true) },
  getGridLoadingState: (state) => { return state.gridLoading },
  getCurrentDocumentIndex: (state) => { return state.currentDocumentIndex },
  getGridLoadingError: (state) => { return state.gridLoadError },
  getSortOrder: (state) => { return state.sortOrder },
  getCriterionFromCriteriaList: (state) => (hash) => {
    return state.criteriaList.findIndex(x => x.Hash === hash) !== -1
  },
  getStoredView: (state) => { return state.storedView },
  getStoredFolderId: (state) => { return state.storedFolderId }
}

const actions = {
}

const mutations = {
  addCriterion (state, criterion) {
    if (criterion !== undefined) {
      criterion.IsApplied = false
      state.criteriaList.push(criterion)
    }
  },
  applyCriterions (state) {
    state.criteriaList.forEach((element, index) => {
      state.criteriaList[index].IsApplied = true
    })
  },
  deleteCriterion (state, {Value, Hash}) {
    if (Value !== undefined) {
      const index = state.criteriaList.findIndex(x => x.Value === Value && x.Hash === Hash)
      if (index !== -1) state.criteriaList.splice(index, 1)
    }
  },
  resetCriteriaList (state) {
    state.criteriaList = []
    state.sortOrder = {
      fieldName: '',
      order: 'asc'
    }
  },
  setLoadingState (state) {
    state.gridLoadError = false
    state.gridLoading = true
  },
  setCurrentDocumentIndex (state, index) {
    if (index > 0) { state.currentDocumentIndex = index }
  },
  setLoadedState (state, failed) {
    if (failed != null) {
      state.gridLoadError = true
    }
    state.gridLoading = false
  },
  setSortOrder (state, { field, order }) {
    state.sortOrder.FieldName = field
    state.sortOrder.Order = order
  },
  setStoredViewState (state, view) {
    state.storedView = view
  },
  setStoredFolderIdState (state, id) {
    state.storedFolderId = id
  }
}

export const module = {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/Store/modules/documentGridModule.js